import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom'
//import axios from 'axios';

class EquipmentItem extends Component {

    componentWillMount() {
        let activePhoto = false;
        let activeVideo = false;

        if (this.props.cam_type === 0) {
            activePhoto = true;
            activeVideo = false;
        } else if (this.props.cam_type === 1) {
            activePhoto = false;
            activeVideo = true;
        } else if (this.props.cam_type === 2) {
            activePhoto = true;
            activeVideo = true;
        }

        this.setState({
            activePhoto,
            activeVideo
        });
    }

    pageToEdit() {
        this.props.history.push(`equipment/edit/${this.props.id}`);
    }    

    render() {
        return (
            <li className="list-item" >
                <div className="equipment-image-wrap">
                    <div className="img"
                        style={{ backgroundImage: `url(${this.props.image})` }} />
                </div>
                <div className="text">
                    <div className="name">{this.props.title}</div>
                    <div className="short-characteristics">Ширина: {this.props.width}, Высота: {this.props.height} </div>
                </div>
                {
                    this.props.switchEditDelete ?
                    <div className="actions" >
                        <div className={this.state.activePhoto ? "action-photo" : "action-photo not-exist"}></div>
                        <div className={this.state.activeVideo ? "action-video" : "action-video not-exist"}></div>
                    </div>
                    :
                    <div className="actions" >
                        <div className="action-edit" onClick={() => { this.pageToEdit() }}></div>
                        <div className="action-delete" onClick={this.props.delete()}></div>
                    </div>
                }
            </li>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentItem));


// WEBPACK FOOTER //
// ./src/components/Profile/EquipmentItem.js